import React from 'react';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { HorizontalNavSkeleton } from '@atlassian/jira-horizontal-nav-common/src/ui/horizontal-nav-skeleton/index.tsx';
import { customPracticeQueueRoute } from '@atlassian/jira-router-routes-servicedesk-queue-routes/src/customPracticeQueueRoute.tsx';
import { customIssueRoute } from '@atlassian/jira-router-routes-servicedesk-queue-routes/src/customIssueRoute.tsx';
import { useCurrentRoute } from '@atlassian/jira-platform-router-utils/src/index.tsx';
import { usePathParam } from '@atlassian/react-resource-router';
import { LazyHorizontalNavQueue } from './async-for-paint.tsx';

export const AsyncHorizontalNavQueue = () => {
	const route = useCurrentRoute();
	const [issueKey] = usePathParam('issueKey');

	const isIssueView =
		route.name === customIssueRoute.name ||
		(route.name === customPracticeQueueRoute.name && issueKey);

	const content = !isIssueView && (
		<Placeholder name="horizontal-nav-queue" fallback={<HorizontalNavSkeleton />}>
			<LazyHorizontalNavQueue />
		</Placeholder>
	);

	return content;
};
